<template>
  <div></div>
</template>

<script>
import SwaggerUI from "swagger-ui";
import "swagger-ui/dist/swagger-ui.css";
export default {
  mounted() {
    SwaggerUI({
      domNode: this.$el,
      url: "/swagger/v1/swagger.json"
    });
  }
};
</script>

<style>
</style>